import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-drivers-programacion-agregar',
  templateUrl: './drivers-programacion-agregar.component.html',
  styleUrls: ['./drivers-programacion-agregar.component.scss']
})
export class DriversProgramacionAgregarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
